import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track14BBlue = ({ state, workState, onLabelClick }) => {
	const trackColor = getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE);
	return (
		<g id="Track14BBlue" transform="translate(1640.000000, 947.000000)" className="track">
			<g id="line" stroke={trackColor}
				 strokeLinecap="round" strokeWidth={tracksWidth}>
				<path
					d="M729.717249,279.377384 L741.551732,280.770269 C746.369694,281.337329 750.735118,277.891292 751.302178,273.07333 C751.363627,272.551236 751.378083,272.024679 751.345371,271.5 C750.931853,264.867323 747.509822,258.787296 742.054361,254.992384 L696.093728,223.021372 C689.516441,218.446097 684.464712,212.001046 681.593049,204.521246 L675.298162,188.125 C670.582095,175.841095 656.800895,169.70615 644.51699,174.422217 C642.855593,175.060064 641.270892,175.882053 639.792545,176.8728 L611.341656,195.939792 C600.432009,203.251133 586.035024,202.616567 575.810948,194.37373 L462.872625,103.32079 L462.872625,103.32079"/>

				<TrackArrow
					transform="translate(716.106928, 277.618956) rotate(-174.000000) translate(-716.106928, -277.618956) "
					points="720.106928 285.618956 712.106928 277.618956 720.106928 269.618956"/>

				<line x1="681.632216" y1="273.568902" x2="719.143035" y2="278.13283"/>

				<TrackArrow
					transform="translate(464.289346, 104.733537) rotate(38.000000) translate(-464.289346, -104.733537) "
					points="468.289346 112.733537 460.289346 104.733537 468.289346 96.733537"/>

				<path
					d="M453.442667,96.3080805 L448.631879,92.2838348 C429.169263,76.0032696 404.245405,67.7301745 378.910446,69.1408676 L341.509372,71.2234222 C328.365582,71.9552905 315.206625,70.0847966 302.787412,65.7192479 L255.85659,49.2223251 C246.012852,45.7620963 235.68821,43.8638002 225.257446,43.5963448 L164.86297,42.0477685 M152.179214,41.5495847 L85,40"/>

				<TrackArrow
					transform="translate(166.606555, 42.098974) rotate(-359.000000) translate(-166.606555, -42.098974) "
					points="170.606555 50.0989738 162.606555 42.0989738 170.606555 34.0989738"/>

				<path d="M85,40 L75.7775171,40.3907832 C45.0564901,41.6925216 16.0463347,26.2295856 0,0 L0,0 L0,0" className="connector"/>
			</g>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track14BBlue')}
				coords="301.000000, 49.000000"
				text='14B'
				textCoordsX="6.98486328"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			/>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track14BBlue')}
				coords="724.000000, 239.000000"
				text='14B'
				textCoordsX="6.98486328"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
			/>
		</g>);
};

Track14BBlue.propTypes = trackPropTypes;

export default Track14BBlue;

